import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledHeartFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M7.246.497q.556 0 1.057.052a2.86 2.86 0 0 0-.972 2.185c0 1.284.876 2.21 1.526 2.761.651.552 1.444 1.026 2.027 1.376l.846.507.846-.507c.39-.233.871-.522 1.342-.852.053.405.078.817.078 1.228 0 1.6-.38 3.2-1.318 4.441L15.5 14.51l-.99.99-2.816-2.816c-1.045.81-2.495 1.313-4.448 1.313-5.062 0-6.75-3.375-6.75-6.75S2.184.497 7.246.497"
                        fill="currentColor"
                    />
                    <path
                        d="m11.73 5.745-.108-.064c-1.24-.743-2.891-1.733-2.891-2.947q0-.208.047-.393c.3-1.208 1.963-1.611 2.952-.198 1.091-1.557 3-.833 3 .591 0 .667-.499 1.266-1.153 1.794-.537.433-1.18.818-1.739 1.153z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierFilledHeartFilledSize16Glyph.displayName = 'MagnifierFilledHeartFilledSize16Glyph';
